import * as ActionTypes from './constants';

export const defaultState = () => {
  return {
    pending: false,
    error: null,
    contactFormMessage: '',
    messageSent: false,
  };
};

export function service(state = defaultState(), action) {
  const { error, payload, type } = action;

  if (type === ActionTypes.CHANGE_CONTACT_FORM_MESSAGE) {
    return {
      ...state,
      contactFormMessage: payload,
    };
  }

  if (type === ActionTypes.SUBMIT_CONTACT_FORM_REQUEST) {
    return {
      ...state,
      error: null,
      messageSent: false,
      pending: true,
    };
  }

  if (type === ActionTypes.SUBMIT_CONTACT_FORM_SUCCESS) {
    return {
      ...state,
      contactFormMessage: '',
      error: null,
      messageSent: true,
      pending: false,
    };
  }

  if (type === ActionTypes.SUBMIT_CONTACT_FORM_FAILURE) {
    return {
      ...state,
      error,
      pending: false,
      messageSent: false,
    };
  }

  return state;
}
